export const TOTAL_DATA_GET = 'total/USER_DATA_GET';
export const LOCATION_DATA_GET = 'location/LOCATION_DATA_GET';
export const DASHBOAR_TOP_DATA_GET = 'branchShop/DASHBOAR_TOP_DATA_GET';
export const USER_DATA_GET = 'user/USER_DATA_GET';
export const TOTAL_DATA_TOTAL_GET = 'user/TOTAL_DATA_TOTAL_GET';
export const SERVICE_DATA_GET = 'service/SERVICE_DATA_GET';
export const PROFESSIONAL_DATA_GET = 'service/PROFESSIONAL_DATA_GET';
export const BOOK_DATA_GET = 'service/BOOK_DATA_GET';
export const SELECTED_PROFESSIONAL_GET = 'service/SELECTED_PROFESSIONAL_GET';
export const SELECTED_DATE_GET = 'service/SELECTED_DATE_GET';
export const SELECTED_TIME_GET = 'service/SELECTED_TIME_GET';
export const SELECTED_CARD_ID_GET = 'service/SELECTED_CARD_ID_GET';
export const IS_GROUP_GET = 'service/IS_GROUP_GET';
export const AVAILABILITY_DATA_GET = 'service/AVAILABILITY_DATA_GET';
export const GUESTS_DATA_GET = 'service/GUESTS_DATA_GET';
export const ACTIVE_GUEST_ID_GET = 'service/ACTIVE_GUEST_ID_GET';
export const LOCATION_ID_GET = 'service/LOCATION_ID_GET';
export const ORDER_ID_GET = 'service/ORDER_ID_GET';
export const ORDERS_DATA_GET = 'service/ORDERS_DATA_GET'
export const LOCATION_MAP_DATA_GET = 'location/LOCATION_MAP_DATA_GET';
export const GIFT_AMOUNT_DATA_GET = 'service/GIFT_AMOUNT_DATA_GET';
export const COUPON_AVAILABLE_DATA_GET = 'service/COUPON_AVAILABLE_DATA_GET';
export const MEMBERSHIPS_DATA_GET = 'service/MEMBERSHIPS_DATA_GET';
export const BOOKING_SESSION_ID_GET = 'service/BOOKING_SESSION_ID_GET';
export const BOOKING_NOTES_GET = 'service/BOOKING_NOTES_GET';